import { createSlice } from "@reduxjs/toolkit";
import { PAGELENGTH } from "components/common/ListLayout";
import Api from "services/api";

export const initialState = {
  clientTranslations: [],
  error: null,
  loader: false,
  total: 1,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1,
};

export const clientTranslationSlice = createSlice({
  name: "clientTranslation",
  initialState: initialState,
  reducers: {
    setTranslations: (state, { payload }) => {
      state.clientTranslations = payload?.data ?? payload;
      state.total = payload?.data?.total;
      state.is_more = payload?.data?.is_more;
      state.last_page = payload?.data?.last_page;
      state.current_page = payload?.data?.current_page;
      state.per_page = payload?.data?.per_page;
    },
    setMoreTranslations: (state, { payload }) => {
      state.clientTranslations = state.clientTranslations.concat(payload.data);
      state.total = payload?.data?.total;
      state.is_more = payload?.data?.is_more;
      state.last_page = payload?.data?.last_page;
      state.current_page = payload?.data?.current_page;
      state.per_page = payload?.data?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    clearAllTranslations: (state) => {
      state.clientTranslations = [];
      state.error = null;
      state.loader = false;
      state.total = 0;
      state.is_more = false;
      state.current_page = 1;
      state.per_page = PAGELENGTH;
      state.last_page = 1;
    },
  },
});

// Fetch translation
export const fetchClientTranslationsList =
  (page, params, disableLoader, asyncMode) => async (dispatch) => {
    if (!disableLoader) dispatch(setLoader(true));
    try {
      const result = await Api.fetchclientTranslationList(page, params);
      if (result.status >= 200 && result.status < 300) {
        const data = result?.data?.data;
        if (page > 1) {
          dispatch(setTranslations({ data }));
          if (!disableLoader) dispatch(setLoader(false));
        } else {
          dispatch(setTranslations({ data }));
          if (!disableLoader) dispatch(setLoader(false));
        }
      } else if (result?.status === 422) {
        if (asyncMode) return [];
        dispatch(setError(result.data));
        if (!disableLoader) dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

// Fetch translation by ID
export const getClientTranslationById =
  (transId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.fetchclientTranslationById(transId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.data);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

// Fetch translation logs by ID
export const getClientTransLogs = (transId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.fetchclientTransLogs(transId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data?.message, json?.data?.data);
      console.log("json", json);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

// Update translation
export const updateClientTranslation =
  (data, itemId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.updateTranslation(data, itemId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

// remove Translation
export const removeClientTranslation =
  (itemId, callback) => async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoader(true));
    try {
      const json = await Api.removeTranslation(itemId);
      if (json.status >= 200 && json.status < 300) {
        callback(true, json.data.message);
      } else if (json.status === 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

export const approveQuote = (itemId, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.approveClientQuote(itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const rejectQuote = (itemId, data, callback) => async (dispatch) => {
  dispatch(setError(null));
  dispatch(setLoader(true));
  try {
    const json = await Api.rejectClientQuote(itemId, data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

// Client Cancel Translation
export const clientCancelTranslation =
  (data, itemId, callback) => async (dispatch) => {
    new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.clientCancelTranslation(itemId, data);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };

export const {
  setTranslations,
  setMoreTranslations,
  setError,
  setLoader,
  clearAllTranslations,
} = clientTranslationSlice.actions;

export default clientTranslationSlice.reducer;
export const clientTranslationSelector = (state) => state.clientTranslation;
